export default __webpack_public_path__ + "static/media/shroudofthegods.8e28e1dd.png";